import { DeviceIds, deviceType } from '@/core/environment/deviceType';
import { HomeUiLayout } from '@/services/settingsService/settingsTypes';

const homeUiLayouts: HomeUiLayout[] = [
  'right_centered',
  'left_centered',
  'left_centered_flipped',
];

/* The variant comes exclusively from the `home_ui_layout` Janus setting;
 * non-desktop and unknown values fall back to the control. */
export const resolveHomeUiLayout = ({
  remoteValue,
  isReady,
}: {
  remoteValue: HomeUiLayout;
  isReady: boolean;
}): HomeUiLayout => {
  if (!isReady) return 'right_centered';
  if (deviceType() !== DeviceIds.Desktop) return 'right_centered';
  return homeUiLayouts.includes(remoteValue) ? remoteValue : 'right_centered';
};
